import { useCallback, useEffect, useMemo, useState } from "react";
import { API } from "../../../services/api";
import { buildSuiviParams, groupRowsByPatient, hasNextPage, suiviPageFromResponse } from "../model/suiviLivraisonRules";

// Produits suivis, regroupés par patient, chargés page par page ; tout changement de filtre repart de la première page.
export function useSuiviPatients(filters, ehpadsLoaded) {
    const { dateReception, ehpadId, tournee, patientSearch, produitSearch, statutMode } = filters;
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    const refresh = useCallback(() => {
        if (!ehpadsLoaded) return;
        if (page > 0) setLoadingMore(true);
        else setLoading(true);
        const params = buildSuiviParams({ dateReception, ehpadId, tournee, patientSearch, produitSearch, statutMode }, page);
        API.get(`/medicaments/livraison-suivi?${params}`, { noRedirectOn401: true })
            .then(r => {
                const next = suiviPageFromResponse(r.data);
                setRows(current => page === 0 ? next.rows : [...current, ...next.rows]);
                setTotalPages(next.totalPages);
                setTotalElements(next.totalElements);
            })
            .catch(console.error)
            .finally(() => {
                setLoading(false);
                setLoadingMore(false);
            });
    }, [dateReception, ehpadId, ehpadsLoaded, page, patientSearch, produitSearch, statutMode, tournee]);

    useEffect(() => { refresh(); }, [refresh]);

    useEffect(() => {
        setRows([]);
        setPage(0);
    }, [dateReception, ehpadId, patientSearch, produitSearch, statutMode, tournee]);

    const loadMore = useCallback(() => {
        if (loading || loadingMore) return;
        if (!hasNextPage(page, totalPages)) return;
        setPage(current => current + 1);
    }, [loading, loadingMore, page, totalPages]);

    const removeRow = useCallback(id => setRows(prev => prev.filter(r => r.id !== id)), []);
    const grouped = useMemo(() => groupRowsByPatient(rows), [rows]);

    return {
        grouped,
        loading,
        loadingMore,
        hasMore: hasNextPage(page, totalPages),
        totalElements,
        refresh,
        loadMore,
        removeRow,
    };
}
